import { ReactNode, CSSProperties } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Announcement from "./Announcement";
import announcementConfig from "config/announcements.yml";
import SkipToMain from "./SkipToMain";
import { ScrollToTopOnMount } from "./ScrollToTopOnMount";
import { IAnnouncementType } from "types";
import { Breadcrumbs } from "./BreadCrumbs";
import { useLocation } from "react-router-dom";

interface Props {
  bannerHeader?: ReactNode;
  bannerFooter?: ReactNode;
  isShort?: boolean;
  onGrid?: boolean;
  allowAnnouncement?: boolean;
  mainStyle?: CSSProperties;
}

const announcements: IAnnouncementType[] = announcementConfig;

const Layout: React.FC<Props> = ({
  bannerHeader = null,
  bannerFooter = null,
  isShort = false,
  onGrid = true,
  children,
  allowAnnouncement = true,
  mainStyle,
}) => {
  const location = useLocation();
  return (
    <>
      <SkipToMain />
      <Header onGrid={onGrid} />
      {allowAnnouncement && <Announcement entries={announcements} />}
      {bannerHeader && <div>{bannerHeader}</div>}
      <div className="grid-content">
        {/* don't display breadcrumbs on the landing page */}
        {location.pathname !== "/" && <Breadcrumbs />}
      </div>
      <ScrollToTopOnMount />
      <main
        className={isShort ? "short" : undefined}
        style={mainStyle}
        id="maincontent"
        tabIndex={0}
      >
        {children}
      </main>
      {bannerFooter}
      <Footer onGrid={onGrid} />
    </>
  );
};

export default Layout;
